<div class="card">
	<div class="p-grid">
		<div class="p-col-12 p-md-4 d-flex flex-column">
			<div>
				<img src="../../../../../assets/images/doordash.jpg" class="img-fluid" />
			</div>
			<div class="d-flex">
				<div class="ms-0">Focus Interface Enabled</div>

				<fa-icon [icon]="['far', 'check']" size="xl" *ngIf="doorDashStatus?.is_order_protocol_pos" class="ms-auto"></fa-icon>
				<fa-icon [icon]="['far', 'times']" size="2x" *ngIf="!doorDashStatus?.is_order_protocol_pos" class="ms-auto"></fa-icon>
				<p-skeleton *ngIf="!doorDashStatus" class="ms-auto"></p-skeleton>
			</div>
			<div class="w-100">
				<div class="mt-3">Menu Item Price Number</div>
				<p-dropdown
					[(ngModel)]="venueSvc.ooVenue.doordashPriceNumber"
					[options]="venueSvc.priceNumbers"
					[autoDisplayFirst]="false"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div class="mt-3">Mod Price Number</div>
				<p-dropdown
					[(ngModel)]="venueSvc.ooVenue.doordashPriceModNumber"
					[options]="venueSvc.priceNumbers"
					[autoDisplayFirst]="false"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div class="mt-3">DoorDash Menu</div>
				<p-dropdown
					placeholder="Default menu"
					[(ngModel)]="venueSvc.ooVenue.doordashOOMenuId"
					[options]="venueSvc.ooMenus"
					optionLabel="name"
					optionValue="key"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div class="d-flex w-100 mt-3">
					<div class="">Customer name as modifier</div>

					<div class="my-auto ms-auto">
						<p-inputSwitch
							styleclass="ms-auto my-auto"
							(onChange)="changesToSaveChange.emit(true); venueSvc.ooMenuConfigSave(venueSvc.subscriptionOOmenuConfig.value)"
							[disabled]="
								!venueSvc.subscriptionOOmenuConfig.value.venueKey ||
								venueSvc.subscriptionOOmenuConfig.value.venueKey !== venueSvc.subscriptionVenue.value.key
							"
							[(ngModel)]="venueSvc.subscriptionOOmenuConfig.value.dspIncludeCustomerNameOnItem"
						></p-inputSwitch>
					</div>
				</div>
				<div *ngIf="venueSvc.ooVenue.doordashMenuPreviewUrl" style="text-align: center" class="mt-2">
					<a href="https://www.doordash.com/en-CA/store/caf-yafa-natick-1758166/2216810/?preview=1" target="_blank"
						>DoorDash Menu {{ venueSvc.ooVenue.doordashOOMenuId.split("/")[5] }} Preview</a
					>
				</div>
				<div class="mt-2">
					<p-button
						pRipple
						[disabled]="!venueSvc.ooVenue.doordashMenuId"
						styleClass="p-button-raised p-button-info d-flex mx-auto"
						(click)="uploadDoorDashMenu()"
					>
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'cloud-upload-alt']" size="lg" class="ms-1 me-2"></fa-icon>
								Sync DoorDash Menu
							</div>
						</ng-template>
					</p-button>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4 d-flex flex-column">
			<p-divider>Menus</p-divider>
			<div class="d-flex flex-column" *ngFor="let menu of doorDashMenuStatus?.menus">
				<div class="d-flex">
					<div class="ms-0">{{ menu.name }}</div>
					<fa-icon [icon]="['far', 'check']" size="xl" *ngIf="menu.is_active" class="ms-auto"></fa-icon>
					<fa-icon [icon]="['far', 'times']" size="2x" *ngIf="!menu.is_active" class="ms-auto"></fa-icon>
				</div>
				<div>Last updated {{ app.moment(menu.last_successful_menu_update_at).format("l LT") }}</div>
				<div>
					<a [href]="menu.url" target="_blank">View on DoorDash</a>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4 d-flex flex-column">
			<p-divider>Deactivation History</p-divider>
			<div class="d-flex flex-column" *ngFor="let rec of doorDashStatus?.current_deactivations">
				<div class="ms-auto">{{ app.moment(rec.created).format("l") }}</div>
				<div class="ms-0">{{ rec.reason }}</div>

				<div class="ms-2 descriptionText">{{ rec.notes }}</div>
			</div>
		</div>
	</div>
</div>
